/* globals angular, _ */
(function() {
  'use strict';

  function ReverseNewRecipientAddressCtrl ($scope, $rootScope, $state, $uibModalInstance, Historico, id) {

    var vm = this;

    vm.id = id;

    vm.confirm = function () {
        $state.go('enderecos');
        $uibModalInstance.close({})
    };

    vm.closePanel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }

  angular
    .module('mandaeApp')
    .controller('ReverseNewRecipientAddressCtrl', ReverseNewRecipientAddressCtrl);
}());
